import React, { useMemo, useState } from "react";
import Icon from "../../../assets/images/logo-header.svg";
import { Dropdown, Tag, Tooltip } from "antd";
import {
  LogoutOutlined,
  TeamOutlined,
  SmileOutlined,
} from "@ant-design/icons";
import downWhite from "../../../assets/images/down-white.svg";
import { logout } from "utilities/HttpUtility";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomDropDown from "./CustomDropDown";
import AnimalAvatarPicker from "./AnimalAvatarPicker";
import environment from "environment";
import RouteEnum from "constants/RouteEnum";
import { getAnimalEmoji } from "constants/animalAvatars";
import { isAdmin } from "utilities/authSession";

const ENV_BADGE_MAP = {
  development: { label: "DEV", color: "geekblue" },
  eponaDevelopment: { label: "DEV", color: "geekblue" },
  testing: { label: "TEST", color: "orange" },
  alabusTesting: { label: "TEST", color: "orange" },
  eponaTesting: { label: "TEST", color: "orange" },
  production: { label: "PROD", color: "green" },
  eponaProduction: { label: "PROD", color: "green" },
};

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const envBadge = ENV_BADGE_MAP[environment.APP_ENVIRONMENT];
  const [avatarOpen, setAvatarOpen] = useState(false);
  const [animalAvatar, setAnimalAvatar] = useState(
    () => sessionStorage.getItem("animal_avatar") || ""
  );

  const user_name = sessionStorage.getItem("user_name");
  const user_email = sessionStorage.getItem("user_email");
  const displayName = user_name || t("operatorFallback");
  const animalEmoji = useMemo(
    () => getAnimalEmoji(animalAvatar),
    [animalAvatar]
  );

  const recipientNameHandle = (name) => {
    if (!name || name === "") {
      return "";
    }
    let nameParts = name.split(" ");

    if (nameParts.length === 1) {
      return nameParts[0].substring(0, 2).toUpperCase();
    }

    let firstNameInitial = nameParts[0].charAt(0);
    let lastName = nameParts[1];
    let lastNameInitials =
      lastName.length >= 2 ? lastName.substring(0, 2) : lastName.charAt(0);

    return `${firstNameInitial}${lastNameInitials}`;
  };

  const profileitems = [
    {
      key: "avatar",
      icon: <SmileOutlined />,
      label: t("chooseAvatar"),
      onClick: () => setAvatarOpen(true),
    },
    ...(isAdmin()
      ? [
          {
            key: "admin",
            icon: <TeamOutlined />,
            label: t("usersAndInvitations"),
            onClick: () => navigate(RouteEnum.AdminUsers),
          },
        ]
      : []),
    { type: "divider" },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: t("logout"),
      danger: true,
      onClick: logout,
    },
  ];

  return (
    <nav className="navbar navbar-light header-nav">
      <div className="container-fluid px-0">
        <img src={Icon} alt="Calingo" className="navbar-brand" />
        {envBadge &&
          environment.APP_ENVIRONMENT !== "production" &&
          environment.APP_ENVIRONMENT !== "eponaProduction" && (
            <Tag color={envBadge.color} style={{ marginLeft: 8 }}>
              {envBadge.label}
            </Tag>
          )}
        <form className="d-flex">
          <div className="page-header mt7">
            <CustomDropDown />
          </div>

          <ul className="navbar-nav ms-4">
            <li className="nav-item dropdown">
              <Dropdown
                menu={{ items: profileitems }}
                trigger={["click"]}
                placement="bottomRight"
                overlayClassName="app-dropdown profile-dropdown"
              >
                <div
                  className="logout-dropdown"
                  onClick={(e) => e.preventDefault()}
                  role="button"
                  tabIndex={0}
                >
                  <div className="d-flex align-items-center">
                    <div className="me-2 ms-1">
                      <Tooltip title={displayName} placement="bottom">
                        <span
                          className={`user-initial-circle ${
                            animalEmoji ? "user-animal-circle" : ""
                          }`}
                          aria-label={displayName}
                        >
                          {animalEmoji || recipientNameHandle(user_name)}
                        </span>
                      </Tooltip>
                    </div>
                    <div>
                      <div className="text-white poppins-medium fs14 text-capitalize">
                        {displayName}
                      </div>
                      <div className="text-white fs12">{user_email || ""}</div>
                    </div>
                    <div className="ms-3">
                      <img src={downWhite} alt="" className="cursor-pointer" />
                    </div>
                  </div>
                </div>
              </Dropdown>
            </li>
          </ul>
        </form>
      </div>
      <AnimalAvatarPicker
        open={avatarOpen}
        onClose={() => setAvatarOpen(false)}
        onSelected={(id) => setAnimalAvatar(id || "")}
      />
    </nav>
  );
};

export default Header;
